const ChangeActivityReason = Object.freeze({
  TOO_TOURISTY: 'too_touristy',
  NOT_MY_KIND_OF_THING: 'not_my_kind_of_thing',
  TOO_PHYSICAL: 'too_physical',
  TOO_EXPENSIVE: 'too_expensive',
  SOMETHING_ELSE: 'something_else',
  MAKE_MORE_RELAXED: 'make_more_relaxed',
  MAKE_MORE_ACTIVE: 'make_more_active',
  MAKE_MORE_LOCAL: 'make_more_local',
  ELEVATE_THIS_DAY: 'elevate_this_day',
  ADD_SURPRISE: 'add_surprise',
} as const);

export type ChangeActivityReason = (typeof ChangeActivityReason)[keyof typeof ChangeActivityReason];

export const allChangeActivityReasons: [ChangeActivityReason, ...ChangeActivityReason[]] = Object.values(
  ChangeActivityReason
) as [ChangeActivityReason, ...ChangeActivityReason[]];

export const allExperienceReasons: [ChangeActivityReason, ...ChangeActivityReason[]] = [
  ChangeActivityReason.TOO_TOURISTY,
  ChangeActivityReason.NOT_MY_KIND_OF_THING,
  ChangeActivityReason.TOO_PHYSICAL,
  ChangeActivityReason.TOO_EXPENSIVE,
  ChangeActivityReason.SOMETHING_ELSE,
];

export const allDayQuickChanges: [ChangeActivityReason, ...ChangeActivityReason[]] = [
  ChangeActivityReason.MAKE_MORE_RELAXED,
  ChangeActivityReason.MAKE_MORE_ACTIVE,
  ChangeActivityReason.MAKE_MORE_LOCAL,
  ChangeActivityReason.ELEVATE_THIS_DAY,
  ChangeActivityReason.ADD_SURPRISE,
];

export default ChangeActivityReason;
